import { ExtendedFields } from '../services';

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  img: string;
  status?: 'available' | 'outOfStock' | 'archived';
  country?: string;
  extendedFields?: ExtendedFields;
  createdAt: Date;
  updatedAt: Date;
  tags?: Tags;
}

export interface Tags {
  privateTags?: TagList;
  tags?: TagList;
}
export interface TagList {
  tagIds?: string[];
}
